import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IItemCategory } from "src/domain/entities"
import { itemCategoryDeleteService } from "src/domain/services/itemCategory/itemCategoryDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	itemCategory: IItemCategory
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const ItemCategoryDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	itemCategory,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleItemCategoryDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await itemCategoryDeleteService({ id: itemCategory.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [itemCategory, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete ItemCategory: ${itemCategory.name}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleItemCategoryDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
